module.exports = __webpack_public_path__ + "static/img/04_社區公告.e03bd37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/04_社區公告.png
// module id = LeiP
// module chunks = 1